import React, { Component } from 'react';
import {connect} from 'react-redux'
import { Line } from 'react-chartjs-2';


import {
  Badge,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  FormGroup,
  Label,
  Card
} from 'reactstrap';
import {GetListDataPoolAttempt_ACTION, GetListObjectAttemptPost_ACTION } from '../Actions/LogisticActions';

import { Routes } from '../Services/API';
import {responsiveFontSize, responsiveHeight, responsiveWidth, CovertDate } from '../Services/Utilities';
import {DatePicker} from 'reactstrap-date-picker'
import CardHeader from 'reactstrap/lib/CardHeader';
import CardBody from 'reactstrap/lib/CardBody';
import CardTitle from 'reactstrap/lib/CardTitle';

const BLOCK_COLOR = "#D3DAE3"
const BLOCK_BORDER_RADIUS = responsiveFontSize(0.5)
const MARGIN_TOP = responsiveWidth(0.25)
const MARGIN_XY = responsiveFontSize(0.5)
const FLEX_ROW_CENTER = ({flexDirection:'row', display:'flex', alignContent:'center', alignItems:'center'})
var timer 

class PlayerSpecificDashboard extends Component {

    constructor(props) {
      super(props);  
      this.First_Block_Ref = React.createRef()
   
      this.state = {
        DPDropDownOpen: false,
        SelectedDP:{NickName:'-', Topics:[]},
        SelectedTopics:[],
      };

      this.toggleDPDropdown = this.toggleDPDropdown.bind(this)
      this.renderGraph = this.renderGraph.bind(this)
  
}

componentDidMount(){
    this.props.GetDataPoolTopics(this.props.StudentKey)

    
    timer = setTimeout(() => {
        this.setState({
            First_Block_Width:this.First_Block_Ref.current.offsetWidth,
            First_Block_Visible: true
            })
    }, 50);
  
}

toggleDPDropdown(){
    this.setState(prev => ({
        DPDropDownOpen: !this.state.DPDropDownOpen
      }))
}

render(){
    let First_Block_Width = this.state.First_Block_Width
    return(
      <div style = {{marginBottom: responsiveHeight(2)}}>
         <Row style = {{width:'95%', marginLeft:'2%', marginTop:responsiveWidth(0.5)}}>
         <h4 className="fw-normal" style = {{fontSize: responsiveFontSize(1)}}>Player Statistics</h4>
              
              </Row>
              <Row style = {{width:'95%', marginLeft:'2%', marginTop:responsiveWidth(0.5)}}>
                  <Col xs = {3} style = {{backgroundColor:'#D3DAE3', borderRadius:responsiveWidth(0.5), alignContent:'flex-start', alignItems:'flex-start', display:'flex', flexDirection:'column', width:'100%'}}>
                        
                        <div
                        ref = {this.First_Block_Ref}
                        style = {{
                          opacity: this.state.First_Block_Visible ? '100%' : '0%',
                          width:'100%',flexDirection:'row', display:'flex', alignItems:'center', alignContent:'space-between'}}>
                          <div style = {{width:First_Block_Width*0.25, backgroundColor:'white', marginRight:First_Block_Width*0.05, borderRadius:responsiveWidth(0.35), marginTop:responsiveWidth(0.5), marginBottom:responsiveWidth(0.5)}}>
                            <h5 style = {{margin:responsiveFontSize(0.25), textAlign:'center', fontSize: responsiveFontSize(1)}}>Course:</h5>
                          </div>
                          <div style = {{marginRight:First_Block_Width*0.05, borderRadius:responsiveWidth(0.35), marginTop:responsiveWidth(0.5), marginBottom:responsiveWidth(0.5), cursor:'pointer'}}>
                          <Dropdown isOpen={this.state.DPDropDownOpen} toggle={() => {
                            this.setState(prev => ({
                              DPDropDownOpen: !this.state.DPDropDownOpen
                            }))
                          }}>
                            <DropdownToggle caret
                            style = {{backgroundColor:'white',
                            fontSize: responsiveFontSize(0.8), width: First_Block_Width*0.60,
                            textOverflow:'ellipsis', overflow:'hidden', whiteSpace:'nowrap'}}
                            onClick={() => {
                              this.setState(prev => ({
                                DPDropDownOpen: !this.state.DPDropDownOpen
                              }))
                            }}
                            >
                              {this.state.SelectedDP.NickName}
                            </DropdownToggle>
                            <DropdownMenu>
                              {(this.props.DPs ||[]).map((d,i) => (
                                <DropdownItem style = {{ backgroundColor:'white'}} key = {i} onClick={() => {
                                  this.setState(prev => ({
                                    SelectedDP:d,
                                    SelectedTopics:[],
                                    DPDropDownOpen: !prev.DPDropDownOpen
                                  }))
                                }}>{d.NickName}</DropdownItem >
                                
                              ))}
                            </DropdownMenu>
                          </Dropdown>
                          </div>
                          <div style = {{width:First_Block_Width*0.15, backgroundColor:'white', borderRadius:responsiveWidth(0.35), marginTop:responsiveWidth(0.5), marginBottom:responsiveWidth(0.5), cursor:'pointer'}}
                          onClick = {() => {
                            let FromDT = undefined; 
                            let ToDT = undefined; 

                            if(this.state.FromDate && this.state.ToDate){
                                FromDT = CovertDate(new Date(this.state.FromDate))
                                ToDT = CovertDate(new Date(this.state.ToDate))
                            
                            }

                            let VM = ({
                              query_dp_Id: this.state.SelectedDP.Id,
                              Player: this.props.StudentKey,
                              TopicIds: this.state.SelectedTopics,
                              From: FromDT,
                              To: ToDT
                            })

                            this.props.GetAdvancedDataPoolStatistics(VM)
                          }}
                          >
                            <h5 style = {{margin:responsiveFontSize(0.25), textAlign:'center', color:'green', fontWeight:'bolder', fontSize: responsiveFontSize(1.0)}}>➜</h5>
                          </div>
                        
                        </div>
                    <div style = {{
                      width:'100%',
                      backgroundColor:'white',
                      flexDirection:'row', display:'flex', alignItems:'flex-start', alignContent:'flex-start', borderRadius: responsiveFontSize(0)}}>
                         <FormGroup style ={{margin: responsiveFontSize(0.25),
                           flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center'}}>
                            <Label style = {{fontSize: responsiveFontSize(0.8), width: responsiveWidth(5)}}>From</Label>
                            <DatePicker 
                                        value   = {this.state.FromDate} 
                                        onChange= {(v,f) => {
                                          this.setState({
                                            FromDate: v,
                                            FromDateFormat: f
                                          })
                                        }} 
                                        style = {{fontSize: responsiveFontSize(0.8)}}
                                        />
                          </FormGroup>

                    </div>
                    <div style = {{
                      width:'100%',
                      backgroundColor:'white',
                      flexDirection:'row', display:'flex', alignItems:'flex-start', alignContent:'flex-start', borderRadius: responsiveFontSize(0), marginBottom:responsiveWidth(0.5)}}>
                         <FormGroup style ={{margin: responsiveFontSize(0.25),
                           flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center'}}>
                            <Label style = {{fontSize: responsiveFontSize(0.8), width: responsiveWidth(5)}}>To</Label>
                            <DatePicker 
                                        value   = {this.state.ToDate} 
                                        onChange= {(v,f) => {
                                          this.setState({
                                            ToDate: v,
                                            ToDateFormat: f
                                          })
                                        }} 
                                        style = {{fontSize: responsiveFontSize(0.8)}}
                                        />
                          </FormGroup>

                    </div>
                    <div 
                    
                    style = {{width:'100%',display:'flex', flexDirection:'row',
                     width:'100%', backgroundColor:'white',
                      marginTop:responsiveWidth(0.1)}}>

                      <div style = {{width: First_Block_Width*0.5}}>
                          <h5 style = {{ textAlign:'left',width:'100%', marginLeft:responsiveWidth(0.5), fontSize: responsiveFontSize(1.0)}}>Topics</h5>
                      </div>
                      <div style = {{width: First_Block_Width*0.25,opacity: this.state.SelectedTopics.length ? '100%' : '50%', marginRight: First_Block_Width*0.05}}>
                        <h5 style = {{ textAlign:'left', width:'100%', fontSize:responsiveFontSize(0.8)}}>
                              <Badge color = "secondary" style = {{cursor:'pointer'}} onClick = {() => {
                                this.setState({
                                  SelectedTopics:[]
                                })
                              }}>
                                clear selection
                              </Badge>
                            </h5>
                      </div>
                      <div style = {{width: First_Block_Width*0.2,}}>
                        <h5 style = {{ textAlign:'left', width:'100%', fontSize:responsiveFontSize(0.8)}}>
                            <Badge color = "primary" style = {{cursor:'pointer'}} onClick = {() => {
                              this.setState({
                                SelectedTopics:this.state.SelectedDP.Topics.map((t,ti) => t.Id)
                              })
                            }}>
                              select all
                            </Badge>
                          </h5>
                      </div>
                      </div>
                      <div style = {{
                        backgroundColor:'white',
                        height:responsiveHeight(30), overflowY:'scroll',
                     flex:'display', flexDirection:'column',
                     alignItems:'center', alignContent:'center',
                     width:'100%', marginBottom:responsiveWidth(0.5),}}>
                        {this.state.SelectedDP.Topics.map((t,ti) => (
                          <div key = {ti}>
                            <Row style = {{ width:'98%', marginTop:responsiveWidth(0.5), cursor:'pointer',
                           marginLeft:responsiveWidth(0.25), borderBottom:1, borderBottomColor:'#e6e6e6'}} onClick = {() => {
                            let SelectedTopics = this.state.SelectedTopics

                            if(this.state.SelectedTopics.includes(t.Id)){
                              SelectedTopics = SelectedTopics.filter((a) => a != t.Id)
                            }
                            else{
                              SelectedTopics.push(t.Id)
                            }

                            this.setState({
                              SelectedTopics: SelectedTopics
                            })

                          }}>
                            <Col xs = {2} >
                              <h6 
                              style={{fontSize: responsiveFontSize(0.7), width:'100%'}}
                              className={this.state.SelectedTopics.includes(t.Id) ? "text-primary" : "text-secondary"}>{ti+1}</h6>
                            </Col>
                            <Col xs = {9} >
                              <h6 style = {{textAlign:'left', fontSize: responsiveFontSize(0.7)}} className={this.state.SelectedTopics.includes(t.Id) ? "text-primary" : "text-muted"}>{t.Name}</h6>
                            </Col>
                          </Row>
                          {(this.props.DPStats && this.props.DPStats.StatisticsByTopic
                          && ((t.Id+"") in this.props.DPStats.StatisticsByTopic)) ? 
                          <div>
                            <h6 style = {{textAlign:'center', fontSize: responsiveFontSize(0.7)}}>
                              ({this.props.DPStats.StatisticsByTopic[t.Id+""].TotalPlayCorrect}/{this.props.DPStats.StatisticsByTopic[t.Id+""].TotalPlay},  {(100 * this.props.DPStats.StatisticsByTopic[t.Id+""].TotalPlayCorrect/this.props.DPStats.StatisticsByTopic[t.Id+""].TotalPlay).toFixed(2)}%)
                              </h6>
                          </div> : <div/>
                          }
                          </div>
                        ))}
                    </div>
                  </Col>
                  <Col xs = {3} style = {{backgroundColor:'#D3DAE3', marginLeft:10, borderRadius:10, alignContent:'center', alignItems:'center', display:'flex', flexDirection:'column'}}>
                          <Row style = {{flexDirection:'column', flex:'display',
                          alignContent:'center', alignItems:'center',
                           margin: responsiveWidth(0.5),
                           width:'100%', borderRadius:responsiveWidth(0.35), backgroundColor:'white'}}> 
                            <Row style = {{width:'100%'}}>
                              <Col xs = {12}>
                                  <h5 style = {{textAlign:'center', color:'#0099cc', fontSize: responsiveFontSize(1)}}>
                                    Time Played
                                  </h5>
                              </Col>
                             
                            </Row>
                            <Row style = {{width:'100%', backgroundColor:'#e6e6e6'}}>
                              <Col xs = {12} style = {{width:'100%', flexDirection:'column', flex:'display'}}>
                                  <h5 style = {{textAlign:'center', fontSize: responsiveFontSize(1)}}>
                                    {(this.props.DPStats && this.props.DPStats.TotalTimePlayed) ? 
                                    (new Date(this.props.DPStats.TotalTimePlayed  * 1000).toISOString().slice(11, 19)):'-'}
                                  </h5>
                                  <p style = {{textAlign:'center', fontSize: responsiveFontSize(0.7)}} className="text-muted">
                                  hh:mm:ss
                                  </p>
                              </Col>
                             
                            </Row>
                          </Row>

                          <Row style = {{flexDirection:'column', flex:'display',
                          alignContent:'center', alignItems:'center',
                           margin: responsiveWidth(0.25),
                           width:'100%', borderRadius: responsiveWidth(0.35), backgroundColor:'white'}}> 
                            <Row style = {{width:'100%', marginTop: responsiveWidth(0.25),}}>
                            <Col xs = {12}>
                                  <h6 style = {{textAlign:'left', color:'#0099cc', fontSize: responsiveFontSize(0.8)}}>
                                    Games played
                                  </h6>
                              </Col>
                              <Col xs = {12}>
                                  <h1 style = {{textAlign:'left', color:'#0099cc', fontSize: responsiveFontSize(1.8)}}>
                                    {(this.props.DPStats && this.props.DPStats.TotalStatistics) ? 
                                     this.props.DPStats.TotalStatistics
                                     
                                     : '-'
                                  }
                                  </h1>
                              </Col>
                             
                            </Row>
                            <Row style = {{width:'100%', marginTop:responsiveWidth(0.5), marginleft:responsiveWidth(0.25)}}>
                            <Col xs = {12}>
                                  <h6 style = {{textAlign:'left', color:'green', fontSize: responsiveFontSize(0.8)}}>
                                  Correct Games played
                                  </h6>
                              </Col>
                              <Col xs = {12} >
                                  <div style = {{flexDirection:'row', display:'flex', alignItems:'flex-start'}}>
                                  <h1 style = {{textAlign:'left', color:'green', marginRight: responsiveWidth(1.25), fontSize: responsiveFontSize(1.8)}}>
                                    {(this.props.DPStats && this.props.DPStats.Correct) ? 
                                     this.props.DPStats.Correct
                                     
                                     : '-'
                                  }
                                  </h1>
                                 
                                  <h5 style = {{textAlign:'left', color:'green', fontSize: responsiveFontSize(0.9)}}>{(this.props.DPStats && this.props.DPStats.Correct && this.props.DPStats.TotalStatistics) ?
                                   ((this.props.DPStats.Correct/this.props.DPStats.TotalStatistics) * 100).toFixed(2) : ''
                                  }%</h5>
                                  </div>
                                  
                                 
                              </Col>
                              
                            </Row>
                          </Row>
                  </Col>
                  <Col xs = {5} style = {{backgroundColor:'#D3DAE3', marginLeft:responsiveWidth(0.5), borderRadius:responsiveWidth(0.35), alignContent:'center', alignItems:'center', display:'flex', flexDirection:'column'}}>
                    <Row style = {{flexDirection:'column', flex:'display',
                          alignContent:'center', alignItems:'center',
                           margin:responsiveWidth(0.5),
                           width:'100%', borderRadius:responsiveWidth(0.35), backgroundColor:'white'}}>
                      <h6 style = {{textAlign:'center', fontSize: responsiveFontSize(1)}}>
                        Average Games Played
                        </h6>
                      {this.renderGraph()}
                      {(!this.props.DPStats || !this.props.DPStats.avg_all_7_days) ?
                      <div/>: 
                      <p style = {{textAlign:'left',
                       fontSize: responsiveFontSize(0.75)}}>*Band is based on the average nr. of games played by the top 10% and the rest of the players.</p> 
                      }
                    </Row>
                  </Col>
              </Row>
      </div>
    )
  }

  renderGraph(){
    if(!this.props.DPStats || !this.props.DPStats.avg_all_7_days){
      return
    }

    const labels = this.props.DPStats.avg_all_7_days.map((a) => a.date);
    console.log(labels)


    const options = {
      type: 'line',
      plugins: {
        legend: {
          position: 'top',
        },
        title: {
          display: true,
          text: 'Average Games Played (All players, You, Distribution*)',
        },
        scales: {
          y: {
            title: {
              display: true,
              text: 'Questions played'
            }
          },
          x: {
            title: {
              display: true,
              text: 'Date'
            }
          },
        } 
      },
    };
    
    

    const data = {
      labels,
      datasets: [
        {
          label: 'All players',
          data: this.props.DPStats.avg_all_7_days.map((t) => t.avg),
          borderColor: 'rgb(255, 204, 0)',
          backgroundColor: 'rgba(255, 204, 0, 0.00)',
        },
        {
          label: 'You',
          data: this.props.DPStats.avg_you_7_days.map((t) => t.avg),
          borderColor: 'rgb(0, 153, 204)',
          backgroundColor: 'rgba(0, 153, 204, 0.025)',
        },
        {
          label: 'Distribution*',
          data: this.props.DPStats.avg_10p_above_7_days.map((t) => t.avg),
          borderColor: 'rgb(191, 191, 191)',
          backgroundColor: 'rgba(191, 191, 191, 0.2)',
        }
      ],
    };

    return (<Line options={options} data={data} />)
  }

}

//Constant
const DP_TOPICS_SEARCHING_PARAMETER = 'IsDPTopicsSearching'
const DP_TOPICS_DATA_PARAMETER = 'DPsTopics'
const DP_TOPICS_GET_ERROR_PARAMETER = 'DPTopicsGetError'

const DP_STATS_SEARCHING_PARAMETER = 'IsDPStatsSearching'
const DP_STATS_DATA_PARAMETER = 'DPsStats'
const DP_STATS_GET_ERROR_PARAMETER = 'DPStatsGetError'


function MapStateToProps(state) {
    return {
        StudentKey: state.Authorization.student_key,

        DPs:state.Query[DP_TOPICS_DATA_PARAMETER],
        IsDPsSearching: state.Query[DP_TOPICS_SEARCHING_PARAMETER],
        GetDPsError: state.Query[DP_TOPICS_GET_ERROR_PARAMETER],
  
        DPStats:state.Query[DP_STATS_DATA_PARAMETER],
        IsDPStatsSearching: state.Query[DP_STATS_SEARCHING_PARAMETER],
        GetDPStatsError: state.Query[DP_STATS_GET_ERROR_PARAMETER],
      }
  }
  
  const MapDispatchToProps = (dispatch) => {
    return {
       
      GetDataPoolTopics: (Player) => {dispatch(GetListDataPoolAttempt_ACTION({
        SearchParameter: DP_TOPICS_SEARCHING_PARAMETER,
        DataParameter: DP_TOPICS_DATA_PARAMETER,
        GetErrorParameter: DP_TOPICS_GET_ERROR_PARAMETER,
  
        Path: Routes.GetDataPoolTopics,
        Value: Player,
        [DP_TOPICS_SEARCHING_PARAMETER]: true,
        [DP_TOPICS_DATA_PARAMETER]: [],
        [DP_TOPICS_GET_ERROR_PARAMETER]: '',
    }))},
    GetAdvancedDataPoolStatistics: (Data) => {dispatch(GetListObjectAttemptPost_ACTION({
      SearchParameter: DP_STATS_SEARCHING_PARAMETER,
      DataParameter: DP_STATS_DATA_PARAMETER,
      GetErrorParameter: DP_STATS_GET_ERROR_PARAMETER,
  
      Path: Routes.AdvancedDataPoolStatistics,
  
      Body: Data,
  
      [DP_STATS_SEARCHING_PARAMETER]: true,
      [DP_STATS_DATA_PARAMETER]: [],
      [DP_STATS_GET_ERROR_PARAMETER]: '',
  }))},
  
    }
  }
  
  export default connect(MapStateToProps, MapDispatchToProps)(PlayerSpecificDashboard)
  